import locale from "./locale";

export default {
    methods: {
        lang(id : string) : string {
            return locale.get(id);
        },
        formatAmount(amount) {
            if (amount === null || amount === undefined || amount === '') {
                return '0.00';
            }
            const numeric = Number(String(amount).replace(/,/g, ''));
            if (Number.isNaN(numeric)) {
                return String(amount);
            }
            return numeric.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        },
    }
}